import { Flex } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { getDealerDefaultLanguage } from 'selectors/dealerSelectors';
import Badge from 'ui/base/Badge';
import Popconfirm from 'ui/base/Popconfirm';

/** @type {React.FC<{ language: string, isError: boolean, canDelete: boolean, className: string, onDelete: () => void, }>} */
const LanguageTab = ({ language, onDelete, canDelete, className, isError = false }) => {
  const defaultLanguage = useSelector(getDealerDefaultLanguage);
  const isDefaultLanguage = language === defaultLanguage;
  const showDelete = canDelete ?? !isDefaultLanguage;

  const handleDelete = React.useCallback(() => {
    onDelete(language);
  }, [language, onDelete]);

  return (
    <Flex gap={8} data-cy={`langTab-${language}`} className={className} align="center">
      <FormattedMessage status="error" id={`language.${language}`} defaultMessage={language} />
      {isError && <Badge status="error" />}
      {showDelete && (
        <Popconfirm
          placement="topRight"
          title={<FormattedMessage id="removeLanguage" defaultMessage="Do you want to delete this language? All unsaved data linked to this language will be lost." />}
          onConfirm={handleDelete}
        >
          <i className="fb-icon--close" data-cy={`langTab-${language}-delete`} />
        </Popconfirm>
      )}
    </Flex>
  );
};

export default LanguageTab;
